export const AP_STATUS = Object.freeze({
  arrived: 'arrived', // AR
  canceled: 'canceled', // CA
  confirmed: 'confirmed', // CF
  customerUnverified: 'customer_unverified', // CU
  deleted: 'deleted', // DE
  needsPayment: 'needs_payment', // NP
  noShow: 'no_show', // NS
  paid: 'paid', // CO
  unconfirmed: 'unconfirmed', // UN

  //
  finished: 'finished', // old status
});

// NOTE: this is old haphazardly made enumeration
// DEPRECATED: use AP_STATUS instead
/*
const APST = Object.freeze({
  arrived: AP_STATUS.arrived, // AR
  cancelled: AP_STATUS.canceled, // CA
  confirmed: AP_STATUS.confirmed, // CF
  customerUnverified: AP_STATUS.customerUnverified, // CU
  deleted: AP_STATUS.deleted, // DE

  // missing NP

  noShow: AP_STATUS.noShow, // NS
  paid: AP_STATUS.paid, // CO
  unconfirmed: AP_STATUS.unconfirmed, // UN

  //
  finished: AP_STATUS.finished, // old status

  //
  error: 'error',
  notArrived: 'not_arrived',
  onlineUnconfirmed: 'online_unconfirmed',
  preferred: 'preferred',
  update: 'update',
});
*/
